// import storageService from '@/services/storage'
// import type { UserStorageInfo } from '@/types/login'

import type { EmployeeDetails } from '@/types/employee'

export default {
  getUserNavbarItems: (
    userInfo: { role: 'employee'; data: EmployeeDetails } | { role: 'admin' }
  ) => {
    const userItems: { value: string; routeName: string }[] = []

    if (userInfo.role === 'employee') {
      if (userInfo.data.isMarketer) {
        userItems.push({ value: 'Create Voucher Batch', routeName: 'CreateNewVoucherBatch' })
      }
    } else {
      userItems.push({ value: 'Create New Employee', routeName: 'CreateNewEmployee' })
    }

    return userItems
  }
}
